<ng-content></ng-content>
<div class="flex flex-col gap-4  pt-4">
    <div class="flex flex-col gap-2 w-full" *ngIf="file_upload_mode">
        <div class="w-full flex justify-center">
            <label for="fileInput" class="flex flex-col items-center justify-center w-full h-56 border-2 border-dashed border-[#B8B8FF] rounded-xl cursor-pointer bg-white hover:bg-gray-50 transition" [ngClass]="{'border-blue-500 bg-blue-50 scale-[1.01] shadow-md': is_dragging && !is_uploading,'border-gray-300 bg-gray-50 hover:bg-gray-100': !is_dragging, 'pointer-events-none opacity-50': error_message || is_uploading }" (dragover)="on_drag_over($event)" (dragleave)="on_drag_leave($event)" (drop)="on_drop($event)">
                <div class="flex flex-col items-center justify-center pt-5 pb-6">
                    <div class="w-16 h-16 mb-3 flex items-center justify-center">
                        <img src="../../../assets/file-uplod-bulk.png" alt="">
                    </div>
                    <p class="mb-2 font-normal text-[16px] leading-[100%] tracking-[0.02em] text-[#666666]">
                        Drag and drop a file or
                        <span class="text-primary font-medium cursor-pointer hover:underline">
                            browse file
                        </span>
                    </p>
                    <p class="text-[14px] font-normal italic leading-[100%] tracking-[0.02em] capitalize text-[#666666]">
                        (Supported Only .CSV File)
                    </p>
                    <p class=" text-[14px] font-medium leading-[100%] tracking-[0.02em] uppercase text-[#666666] my-2"> OR</p>
                    <button (click)="download_template()" class="text-[14px] font-medium leading-[100%] tracking-[0em] text-center capitalize underline text-primary"> Download Template</button>
                </div>
                <input id="fileInput" type="file" class="hidden" [accept]="accepted_type" (change)="on_file_change($event)" />
            </label>
        </div>
    </div>

    <div *ngIf="error_message" class="text-red-600 whitespace-pre-line">{{ error_message }}</div>

    <div *ngIf="!file_upload_mode && enable_preview && display_data.length > 0" class="end-full bg-white border border-primary rounded-lg  overflow-x-auto max-h-[400px] overflow-y-auto">
        <table class="table-auto text-text-color-600 w-full border-collapse">
            <thead class="text-sm font-medium text-primary-500 border-b border-[#CFD5F1] tracking-[0.8px]">
                <tr>
                    <th *ngFor="let key of display_data[0] | keyValueWithOrder" class="px-2 md:px-4 h-10 md:h-12  text-xs md:text-sm text-center truncate">{{ key.key }}</th>
                </tr>
            </thead>
            <tbody class="text-sm font-normal text-black/87 tracking-[0.32px]">
                <tr *ngFor="let row of display_data; let i = index" class="border-b border-[#CFD5F1] truncate">
                    <td *ngFor="let key of row | keyValueWithOrder" class="px-2 md:px-4 h-10 md:h-12  text-xs md:text-sm text-center truncate">{{ row[key.key] }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div *ngIf="!file_upload_mode && error_report.length > 0" class="flex flex-col gap-1 max-h-[200px] overflow-y-auto">
        <ng-container *ngFor="let errs of error_report; let i = index">
            <div *ngFor="let err of errs" class="text-red-600 text-sm bg-red-50 border border-red-200 rounded px-3 py-1">
                <!-- <span class="font-medium">Row {{ i + 1 }}:</span>  -->
                {{ err }}
            </div>
        </ng-container>
    </div>

    <div class="flex items-center w-full gap-4" [ngClass]="!file_upload_mode ? 'justify-between' : 'justify-end'">
        <button *ngIf="!file_upload_mode || error_message" class="border border-primary text-primary font-medium cursor-pointer rounded-full text-sm px-6 h-10 text-center hover:shadow-md focus:shadow-lg" (click)="reupload()">Reupload</button>
        <div class="flex gap-4 ">
            <app-button class="relative self-end" [label]="'discard'" (click)="cancel.close()" color="border-t-[0.8px] border-t-[rgba(209,213,220,1)] bg-withe text-slate-700"> </app-button>
            <app-button class="relative self-end" [label]="'Add'" (click)="on_submit()" color="bg-primary text-white" [disabled]="error_message !== '' || display_data.length == 0 || disabled"> </app-button>
        </div>
    </div>
</div>